
import { createContext, useEffect, useMemo, useState } from "react";
import { fetchPublicSettings } from "./settingsPublicApi";

export const SettingsContext = createContext({ settings: null, isLoading: true, error: "", refreshSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  async function load(signal) { setIsLoading(true); setError(""); try { setSettings(await fetchPublicSettings({ signal })); } catch (err) { if (err.name !== "AbortError") setError(err.message || "Settings unavailable."); } finally { if (!signal?.aborted) setIsLoading(false); } }
  useEffect(() => { const controller = new AbortController(); load(controller.signal); return () => controller.abort(); }, []);
  const value = useMemo(() => ({ settings, isLoading, error, refreshSettings: () => load() }), [settings, isLoading, error]);
  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}
